import { createRouter, createWebHistory } from 'vue-router'
import { contextBase } from '../management-context.mjs'
import { apiBaseUrl } from '../runtime-config.mjs'

const base = contextBase(window.location.pathname)

const routes = [
  {
    path: '/',
    redirect: '/settings/profile'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { title: '登录 - AutoSquare' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/RegisterView.vue'),
    meta: { title: '注册 - AutoSquare' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPasswordView.vue'),
    meta: { title: '重置密码 - AutoSquare' }
  },
  {
    path: '/oauth/callback/:provider',
    name: 'OAuthCallback',
    component: () => import('../views/OAuthCallbackView.vue')
  },
  {
    path: '/settings',
    component: () => import('../layouts/SettingsLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/settings/profile'
      },
      {
        path: 'profile',
        name: 'SettingsProfile',
        component: () => import('../views/SettingsProfileView.vue'),
        meta: { title: '个人资料 - AutoSquare' }
      },
      {
        path: 'emails',
        name: 'SettingsEmails',
        component: () => import('../views/SettingsEmailsView.vue'),
        meta: { title: '邮箱设置 - AutoSquare' }
      },
      {
        path: 'authorized-apps',
        name: 'SettingsAuthorizedApps',
        component: () => import('../views/SettingsAuthorizedAppsView.vue'),
        meta: { title: '已授权应用 - AutoSquare' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(base),
  routes: [...routes,
    { path: '/management/enter', component: () => import('../views/ManagementEnterView.vue') },
    { path: '/management/ended', component: () => import('../views/ManagementEndedView.vue') }
  ]
})

import { useAuthStore } from '../store/auth'

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore()
  if (base === '/' && to.meta.requiresAuth) {
    window.location.replace(`${apiBaseUrl(window.location)}/management/start/?target=account&return_path=${encodeURIComponent(to.fullPath)}`)
    return next(false)
  }
  if (base !== '/' && ['/login', '/register', '/forgot-password'].includes(to.path)) return next('/management/ended')
  if (to.meta.requiresAuth) await auth.fetchProfile()
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    next({ path: '/management/ended', query: { unavailable: auth.profileStatus === 503 ? '1' : undefined } })
  } else {
    next()
  }
})

// Dynamic Title
router.afterEach((to) => {
  document.title = to.meta.title || 'AutoSquare 帐号中心'
})

export default router
